// @flow
import type { CurrentUser } from 'api/currentUser';
import { isAfter, parseISO } from 'date-fns';
import { getItem, setItem } from 'utils/localStorage';
import { configValue } from 'utils/config';
import { isDefined } from 'utils/functional';
import { isNonAdmin } from 'utils/currentUser';

const NEW_USER_DATE = new Date('08/20/2020');

const RESUME_DB_DISMISSED_KEY = 'resumeDatabaseDismissed';

const isDismissedLoggedOut = () => getItem(RESUME_DB_DISMISSED_KEY) === 'true';

export const dismissResumeDBLoggedOut = () =>
  setItem(RESUME_DB_DISMISSED_KEY, 'true');

export const promoteResumeDatabase = ({
  currentUser,
  includeDate,
  allowLoggedOut
}: {
  currentUser: CurrentUser,
  includeDate?: boolean,
  allowLoggedOut?: boolean
}) =>
  configValue('idealist', 'resumeDb', 'enabled') &&
  !isDismissedLoggedOut() &&
  ((allowLoggedOut && currentUser && !currentUser.id) ||
    (isNonAdmin(currentUser) &&
      !isDefined(currentUser.isRecruitable) &&
      !currentUser.resumeId)) &&
  (!includeDate || isAfter(parseISO(currentUser.created), NEW_USER_DATE));
